import { render, staticRenderFns } from "./blog-ad.vue?vue&type=template&id=e2deeab4&scoped=true&"
import script from "./blog-ad.vue?vue&type=script&lang=js&"
export * from "./blog-ad.vue?vue&type=script&lang=js&"
import style0 from "./blog-ad.vue?vue&type=style&index=0&id=e2deeab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2deeab4",
  null
  
)

export default component.exports